import React  from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import ProjectDescription from "./ProjectDescription";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import pdf from "../../assets/CV_VICTOR_IGUALADA.pdf";
import akkaLogo from "../../assets/Resume/akka.png";
import beLogo from "../../assets/Resume/beroomers.png";
import capLogo from "../../assets/Resume/cap-logo.jpeg";
import parrableLogo from "../../assets/Resume/parrable-logo.png";
import lfvalLogo from "../../assets/Resume/lfval-logo.png";
import uvLogo from "../../assets/Resume/uv-logo.png";
import CompanyDescription from './CompanyDescription';
import LanguageDescription from './LanguageDescription';

function Resume() {

  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download CV
          </Button>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <CompanyDescription
              company="Parrable"
              companyLogo={parrableLogo}
            />
            <ProjectDescription
              title="Internet Engineer"
              date="May 2020 - Present"
              description="Working on the Advertising world, mainly developing a device fingerprinting system."
              stack={[
                "NodeJS",
                "Aerospike",
                "Docker"
              ]}
            />
            <CompanyDescription
              company="Capgemini"
              companyLogo={capLogo}
            />
            <ProjectDescription
              title="Consultant Architect and Software Engineer"
              date="Aug 2019 - May 2020"
              description="Engaged in a project for SNCF (French train national enterprise) for planning and organizing train and asset maintenances among the whole country. Designed and developed the system architecture following architectural patterns"
              stack={[
                "NodeJS",
                "Nest framework",
                "MongoDB",
                "Oracle Database",
                "TypeORM",
                "API Driven Development",
                "Docker"
              ]}
            />
            <ProjectDescription
              title="Consultant Software Engineer"
              date="Mar 2019 - Aug 2019"
              description="Commited in an internal project aiming workplace and seat reservation among all international building around the world. Due to the high volume of users, traditional databases and services where useless. Queuing with Kafka for user requests (writing) and caching data with Redis (reading). Architectural design and Back-End implementation then of a IaaS."
              stack={[
                "NodeJS",
                "Nest framework",
                "Microservices",
                "CQRS",
                "Kafka",
                "Redis",
                "Domain Driven Development",
                "Docker"
              ]}
            />
            <ProjectDescription
              title="Java Software Engineer"
              date="Feb 2019 - Mar 2019"
              description="Development of a Proof of Concept for an electrical french company, aiming the centralization of business rules. Implementing of a web Back-End using BPMN and CMMN graphic notations"
              stack={[
                "Java",
                "Camunda",
                "DevonFW",
                "Docker"
              ]}
            />
            <CompanyDescription
              company="AKKA"
              companyLogo={akkaLogo}
            />
            <ProjectDescription
              title="Consultant Software Engineer"
              date="Nov 2018 - Feb 2019"
              description="Engaged in Telespazio, a Thalés and Leonardo Company, for developing a security mid-end server to secure socket communications between client (Android and IoT) and the precise positioning servers (RTCM, CASTER, RxNetwork) in a satellite navigation project. The goal of the project was to reduce Positioning Systems error from 10 meters (actual error) to 1 meter."
              stack={[
                "Java and C development",
                "SpringBoot and SpringSecurity",
                "Single Sign On (Keycloak, JWT)",
                "Sockets",
                "Concurrency",
                "Algorithm creation for raw navigation data processing",
                "Clustering",
                "Navigation protocols (NTRIP, NMEA)"
              ]}
            />
            <ProjectDescription
              title="Consultant Software Engineer"
              date="Jul 2018 - Nov 2018"
              description="Engaged in AIRBUS Defence & Space project for satellite flight dynamics control. Desktop application and server context that allow the user to run satellite control and monitoring algorithms"
              stack={[
                "Spring Framework",
                "RESTful API",
                "JWT security",
                "Development of a ciphering library",
                "Simple FORTRAN algorithms edition",
                "C++ interfaces between Java and FORTRAN algorithms"
              ]}
            />
            <ProjectDescription
              title="Consultant Software Engineer"
              date="Mar 2018 - Jul 2018"
              description="Engaged in intern Big Data project at AKKA Research. The project AUTOPILOT is an European project for studying the positive impact of IoT in autonomous driving."
              stack={[
                "FullStack Development",
                "Spring Framework",
                "RESTful API",
                "Controller-Service-Respository Architecture",
                "SpringSecurity and Role management (JSON Web Token)\n",
                "SwaggerUI",
                "Desktop applications with Java Swing"
              ]}
            />
            <CompanyDescription
              company="Beroomers"
              companyLogo={beLogo}
            />
            <ProjectDescription
              title="Full-stack Developer"
              date="Sept 2016 - Fev 2017"
              description="Back-End development in PHP for accommodation start-up Beroomers. The goal was developing a Key Indicator Panel that allows business and commercial employees to better understand the metrics of the enterprise thank of graphics. The complexity of this project lies in the SQL querys for retrieving information from several tables and databases and making it usable."
              stack={[
                "PHP Symfony2 development",
                "HighCharts ECMAScript5 lib",
                "Bootstrap",
                "MySQL"
              ]}
            />
            <ProjectDescription
              title="Consultant Software Engineer"
              company="AKKA Technologies"
              compnayLogo=""
              date="Sept 2016 - Fev 2017"
              description="Back-End development in PHP for accommodation start-up Beroomers. The goal was developing a Key Indicator Panel that allows business and commercial employees to better understand the metrics of the enterprise thank of graphics. The complexity of this project lies in the SQL querys for retrieving information from several tables and databases and making it usable."
              stack={[
                "PHP Symfony2 development",
                "HighCharts ECMAScript5 lib",
                "Bootstrap",
                "MySQL"
              ]}
            />
          </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <CompanyDescription
              company="Universitat de València"
              companyLogo={uvLogo}
            />
            <ProjectDescription
              title="Bachelor's degree in Telematics Engineering"
              date="2012 - 2017"
            />
            <CompanyDescription
              company="Lycèe Français de Valence"
              companyLogo={lfvalLogo}
            />
            <ProjectDescription
              title="Diplôme National du Baccalauréat, Sciences - Spé SVT. Cell biology, anatomy and geology"
              date="1996 - 2010"
            />
            <br />
            <br />
            <br />
            <h3 className="resume-title">Languages</h3>
            <LanguageDescription
              language="Spanish"
              description="Native"
              rank="5"
            />
            <LanguageDescription
              language="French"
              description="Native"
              rank="5"
            />
            <LanguageDescription
              language="English"
              description="Professional"
              rank="4"
            />
            <LanguageDescription
              language="Catalan"
              description="Native"
              rank="5"
            />
            <LanguageDescription
              language="Italian"
              description="Basic"
              rank="2"
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download CV
          </Button>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
